export function initCarousel() {
    document.querySelectorAll('.carousel').forEach(function (carousel) {
        if (carousel.dataset.initialized) return;
        carousel.dataset.initialized = 'true';

        const inner = carousel.querySelector('.carousel-inner');
        const items = carousel.querySelectorAll('.carousel-item');
        const prevBtn = carousel.querySelector('.carousel-control-prev');
        const nextBtn = carousel.querySelector('.carousel-control-next');
        const indicators = carousel.querySelectorAll('.carousel-indicator');
        const autoPlay = carousel.dataset.autoplay === 'true';
        const interval = parseInt(carousel.dataset.interval) || 5000;

        let currentIndex = 0;
        let autoPlayInterval = null;

        function goToSlide(index) {
            if (index < 0) index = items.length - 1;
            if (index >= items.length) index = 0;

            currentIndex = index;
            inner.style.transform = `translateX(-${currentIndex * 100}%)`;

            indicators.forEach(function (ind, i) {
                ind.classList.toggle('active', i === currentIndex);
            });
        }

        function nextSlide() {
            goToSlide(currentIndex + 1);
        }

        function prevSlide() {
            goToSlide(currentIndex - 1);
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                prevSlide();
                resetAutoPlay();
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                nextSlide();
                resetAutoPlay();
            });
        }

        indicators.forEach(function (indicator, index) {
            indicator.addEventListener('click', function () {
                goToSlide(index);
                resetAutoPlay();
            });
        });

        function startAutoPlay() {
            if (autoPlay && items.length > 1) {
                autoPlayInterval = setInterval(nextSlide, interval);
            }
        }

        function resetAutoPlay() {
            if (autoPlayInterval) {
                clearInterval(autoPlayInterval);
                startAutoPlay();
            }
        }

        carousel.addEventListener('mouseenter', function () {
            if (autoPlayInterval) clearInterval(autoPlayInterval);
        });

        carousel.addEventListener('mouseleave', function () {
            startAutoPlay();
        });

        if (indicators.length > 0) {
            indicators[0].classList.add('active');
        }

        startAutoPlay();
    });
}
